import Sell from "./sell";

export default Sell;
